import { useEventListener, useMountEffect } from "@react-hookz/web";
import { useCallback } from "react";

export const getFontSize = (
  lengthToFit: number,
  availableWidth: number,
  rowHeight: number,
  verticalPaddingRatio: number
) => {
  const fontSizeToWidthRatio = 100 / 60; // with Noto Mono
  const widthBased = fontSizeToWidthRatio * (availableWidth / lengthToFit);
  const verticalPadding = rowHeight * verticalPaddingRatio;
  const heightBased = rowHeight - verticalPadding;
  return Math.min(widthBased, heightBased);
};

export const getRect = (
  element: HTMLElement | null | undefined,
  rotatedToSide: boolean
) => {
  const rect = element?.getClientRects()[0] || {
    width: 0,
    height: 0,
  };
  return rotatedToSide ? { width: rect.height, height: rect.width } : rect;
};

/**
 * On window resize, after browser repaint.
 */
export const useOnResize = (listener: (...args: unknown[]) => unknown) => {
  const onResize = useCallback(
    () => void requestAnimationFrame(listener),
    [listener]
  );
  useEventListener(window, "resize", onResize);
  useMountEffect(onResize);
};
